import styles from './styles.module.css'

const TeamCard = (props) => {
    const {image,name,designation} = props.item;
    return (
        <div className="col-12 col-md-6 col-lg-3 mb-4">
            <div className={styles['team-card']}>
                <div className={styles['image']}>
                    <img 
                        alt='Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
                        src={image || 'https://placehold.co/450x400/jpg'}
                        style={{ width: '100%', height: 'auto' }}
                    />
                </div>
                <div className={styles['info']}>
                    <h4>{name}</h4>
                    <p>{designation}</p>
                </div>
            </div>
        </div>
    );
};

export default TeamCard;